<template>
  <b-card class="sa-card sa-card-border" header="Struttura - Presidio" header-tag="header" footer-tag="footer" title="">
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <label>Presidi</label>
        <b-form-select id="inline-form-custom-select-pref" v-model="localData.idPresidio" class="mb-2 mr-sm-2 mb-sm-0"
          @change="onChangePresidio">
          <template #first>
            <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
          </template>
          <template>
            <b-form-select-option v-for="pres of presidiOptions" :value="pres.idPresidio" :key="pres.id"> {{
              pres.denominazionePresidio }} ({{ pres.denominazioneStruttura }}) </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  props: {
    jsonData: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    isEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  mixins: [UtilityMixin],
  data() {
    return {
      localData: {
        idPresidio: null,
        codiceStruttura: null,
        settingCodice: null,
        regime: null,
        settingDescrizione: null,
      },
      linkStrutture: "/strutture",
      strutturaOptions: [],
      linkPresidi: "/strutturepresidi",
      presidiOptions: [],
      linkRegimi: "/accettazioneregimi",
      regimiOptions: [],
      linkSettingPresidi: "/rsasettingspresidi",
      settingsPresidiOptions: [],
    };
  },
  mounted() {
    let me = this;
    if (this.jsonData) {
      this.localData = { ...this.jsonData };
    }
    me.loadUserData();



    //me.loadStrutture();


    // if (me.localData.codiceStruttura) {
    //   me.localData.idPresidio = null;
    //   me.strutturaOptions.forEach((element) => {
    //     if (element.codiceStruttura === me.localData.codiceStruttura) {
    //       me.loadPresidi(element.id);
    //     }
    //   });
    // }
  },
  methods: {
    emitChange() {
      this.$emit("changeJsonData", { ...this.localData });
    },
    loadStrutture() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.linkStrutture, null, me.loadStruttureSuccess, me.loadStruttureError);
    },
    loadUserData() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/users/profile";
      axios
        .get(link)
        .then((response) => {
          let utente = response.data.data;

          me.loadDataUtentiPresidio(utente.id);
        })
        .catch((e) => {
          //this.errors.push(e);
          console.log(e);
        });
    },
    loadStruttureSuccess(response) {
      let me = this;
      me.strutturaOptions = [];
      me.rows = response.data.data.recordsNumber;
      me.strutturaOptions = response.data.data;
    },
    loadStruttureError() {
    },

    onChangeStruttura(value) {
      let me = this;
      me.localData.regime = null;
      me.localData.settingDescrizione = null;
      me.localData.settingCodice = null;
      me.localData.idPresidio = null;
      me.strutturaOptions.forEach((element) => {
        if (element.codiceStruttura === value) {
          me.loadPresidi(element.id);
        }
      });
      me.emitChange();
    },
    loadDataUtentiPresidio(id) {
      let me = this;
      this.openShowModalLoading();
      UtilityMixin.methods.loadDataResources("/utentipresidi", { idUtente: id }, me.loadDataUtentiPresidiSuccess, me.loadDataUtentiPresidiError);
    },
    loadDataUtentiPresidiSuccess(response) {
      let me = this;
      me.presidiOptions = response.data.data.list;
      if (me.presidiOptions.length == 1) {
        me.filtro.idPresidio = me.presidiOptions[0].idPresidio;
        let a = localStorage.getItem("presidio");
        let presidio = JSON.parse(a);
        me.localData.idPresidio = presidio.idPresidio;
        this.localData.codiceStruttura = presidio.codiceStruttura;
        me.emitChange();
        this.closeShowModalLoading();
      } else {
        let a = localStorage.getItem("presidio");
        let presidio = JSON.parse(a);
        me.localData.idPresidio = presidio.idPresidio;
        this.localData.codiceStruttura = presidio.codiceStruttura;
        me.emitChange();
        this.closeShowModalLoading();
      }

    },
    loadDataUtentiPresidiError(error) {
      this.closeShowModalLoading();
      console.log(error);
    },
    loadRegimi() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.linkRegimi, null, me.loadRegimiSuccess, me.loadRegimiError);
    },
    loadRegimiSuccess(response) {
      let me = this;
      console.log(response);

      me.regimiOptions = response.data.data.list;
    },
    loadRegimiError() {
    },
    loadPresidi(value) {
      let me = this;
      me.presidiOptions = [];
      UtilityMixin.methods.loadDataResources(me.linkPresidi, { idStruttura: value }, me.resultLoadPresidiSuccess, me.resultLoadPresidiError);
    },
    resultLoadPresidiSuccess(response) {
      let me = this;
      me.presidiOptions = response.data.data.list;
      if (me.presidiOptions.length === 1) {
        me.localData.idPresidio = me.presidiOptions[0].id;
        me.localData.idPresidio = me.presidiOptions[0].codiceStruttura;
      }
      me.emitChange();
    },
    resultLoadPresidiError() {
    },

    loadSettingsPresidi(id) {
      let me = this;
      let params = { idPresidio: id };
      UtilityMixin.methods.loadDataResources(me.linkSettingPresidi, params, me.resultResponseSettings, me.resultErrorSettings);
    },
    resultResponseSettings(response) {
      let me = this;
      me.settingsPresidiOptions = response.data.data.list;
      if (me.settingsPresidiOptions.length === 1) {
        me.localData.settingCodice = me.settingsPresidiOptions[0].codice;
        me.localData.settingDescrizione = me.settingsPresidiOptions[0].setting;
      }
      me.emitChange();
    },
    resultErrorSettings(response) {
      UtilityMixin.methods.messaggeBoxError(this, response);
    },
    onChangeSettingCodice(value) {
      let me = this;
      me.settingsPresidiOptions.forEach((element) => {
        if (element.codice === value) {
          me.localData.settingDescrizione = element.setting;
          me.emitChange();
        }
      });
    },
    onChangePresidio(value) {
      let me = this;
      me.localData.regime = null;
      me.localData.settingDescrizione = null;
      me.localData.settingCodice = null;
      const presidioSelezionato = this.presidiOptions.find(e => e.idPresidio == value);
      this.localData.codiceStruttura = presidioSelezionato ? presidioSelezionato.codiceStruttura : null;
      me.loadSettingsPresidi(value);
      me.emitChange();
    },
  },
};
</script>

<style lang="scss" scoped></style>
